import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces, Trans } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import MobileHeader from './MobileHeader';

import * as action from '../../store/actions/action';
import { logoWhite } from '../../config';
import sideMenu from '../../config/side-menu';

const SidebarItemHeader = ({ item }) => (
  <li className="nav-heading">
    <span>{item.heading}</span>
  </li>
);
const SidebarItem = ({ item, isActive, handler }) => (
  <li onClick={handler} className={`item ${isActive ? 'active' : ''}`}>
    <Link to={item.path} className="item-title">
      {item.icon && (
        <span className="icon">
          <i className={item.icon} />
        </span>
      )}
      <span className="text">
        <Trans i18nKey={item.translate}>{item.name}</Trans>
      </span>
    </Link>
  </li>
);

const SidebarSubItem = ({ item, isActive, handler, children, isOpen }) => (
  <li className={`item ${isActive ? 'active' : ''}`}>
    <div className="item-title" onClick={handler} onKeyPress={handler} role="button" tabIndex={0}>
      {item.icon && (
        <span className="icon">
          <i className={item.icon} />
        </span>
      )}
      <span className="text">
        <Trans i18nKey={item.translate}>{item.name}</Trans>
      </span>
    </div>
    <Collapse isOpen={isOpen}>
      <ul id={item.path} className="sidebar-nav sidebar-subnav">
        {children}
      </ul>
    </Collapse>
  </li>
);

// const SidebarSubHeader = ({item}) => (
//   <li className="sidebar-subnav-header">{item.name}</li>
// )

class Sidebar extends Component {
  constructor(props) {
    super(props);

    const modules = this.props.account.user && this.props.account.user.modules
      ? this.props.account.user.modules.split(',')
      : [];

    this.state = {
      collapse: {},
      modules,
    };
  }

  closeAside = () => {
    this.props.onCloseAside();
  };

  getSubRoutes = (item) => item.submenu.map(({ path }) => path);

  navigator = () => {
    // this.props.history.push(route.replace('#','')); // remove '#' in case of use HashRouter
  };

  itemType = (item) => {
    if (item.heading) return 'heading';
    if (item.submenu) return 'submenu';
    return 'menu';
  };

  hasAccess = (item) => {
    switch (this.itemType(item)) {
      case 'header':
        return true;

      case 'submenu':
        const modules = Array.isArray(item.submenu)
          ? item.submenu.map((subItem) => subItem.module)
          : [];
        for (const module of modules) {
          if (this.state.modules.includes(module)) return true;
        }
        return false;

      default:
        const { module } = item;
        return !module || this.state.modules.includes(module);
    }
  };

  routeActive(paths) {
    paths = Array.isArray(paths) ? paths : [paths];
    return !!paths.includes(this.props.location.pathname);
  }

  toggleItemCollapse(stateName) {
    for (const c in this.state.collapse) {
      if (this.state.collapse[c] === true && c !== stateName) {
        this.setState({
          collapse: {
            [c]: false,
          },
        });
      }
    }
    this.setState({
      collapse: {
        [stateName]: !this.state.collapse[stateName],
      },
    });
  }

  render() {
    return (
      <>
        <MobileHeader />
        <aside className="main-sidebar">
          <div className="inner-scroll">
            <button className="menu-button" onClick={this.closeAside} type="button">
              <i className="icon-close" />
            </button>
            <figure className="logo">
              <img src={logoWhite} alt="logo" />
            </figure>

            <figure className="avatar">
              <img
                src={
                  this.props.account.user && this.props.account.user.profilePhoto
                    ? this.props.account.user.profilePhoto
                    : '/uploads/default.jpg'
                }
                alt="Organization Logo"
              />
            </figure>


            <h6 className="name sidebar-name mt-3">
            {
                this.props.account.user ?
                  this.props.account.user.preferredName || `${this.props.account.user.firstName} ${this.props.account.user.lastName}`
                  : null
              }

            </h6>

            <hr className="sidebar-hr"/>

            <div className="content-wrapper">
              <ul className="navigator">
                {sideMenu.map((item, i) => {
                  if (this.hasAccess(item)) {
                    switch (this.itemType(item)) {
                      case 'heading':
                        return <SidebarItemHeader item={item} key={i} />;
                      case 'submenu':
                        return [
                          <SidebarSubItem
                            item={item}
                            isOpen={this.state.collapse[item.name]}
                            handler={this.toggleItemCollapse.bind(this, item.name)}
                            isActive={this.routeActive(this.getSubRoutes(item))}
                            key={i}
                          >
                            {item.submenu.map((subItem, i) => (this.hasAccess(subItem) ? (
                              <SidebarItem
                                handler={this.closeAside}
                                key={i}
                                item={subItem}
                                isActive={this.routeActive(subItem.path)}
                              />
                            ) : null))}
                          </SidebarSubItem>,
                        ];
                      default:
                        return (
                          <SidebarItem
                            handler={this.closeAside}
                            isActive={this.routeActive(item.path)}
                            item={item}
                            key={i}
                          />
                        );
                    }
                  }

                  return null;
                })}
              </ul>
            </div>
          </div>
        </aside>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  account: state.accountReducer,
});

const mapDispatchToProps = (dispatch) => ({
  onCloseAside: () => dispatch({ type: action.CLOSE_ASIDE }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces('translations')(withRouter(Sidebar)));
